angular
  .module('components.inicial', [
    'ui.router'
  ]);
